import React from 'react';
import { Row, Col, Icon } from 'antd';
import { useTranslation } from 'react-i18next';

export default function SearchMessageDetailsLearnBlock() {
  const { t } = useTranslation()
  return (
    <>
      <div
        style={{
          height: '400px',
          backgroundColor: '#F9F9F9',
          paddingTop: '150px'
        }}
      >
        <Row type="flex" justify="center" align="top">
          <Col lg={5} xs={18} style={{ padding: '10px' }}>
            <Icon type="search" />
            <h3 style={{ color: '#877398' }}>{t('1. Search')}</h3>
            <p>
              {t('Find the right tutor to fit with your location, schedule and learning style and objectives')}
            </p>
          </Col>
          <Col lg={5} xs={18} style={{ padding: '10px' }}>
            <Icon type="search" />
            <h3 style={{ color: '#877398' }}>{t('2. Message')}</h3>
            <p>
              {t('Get in contact with your tutor with our convenient messaging platform and agree a time')}
            </p>
          </Col>
          <Col lg={5} xs={18} style={{ padding: '10px' }}>
            <Icon type="search" />
            <h3 style={{ color: '#877398' }}>{t('3. Details')}</h3>
            <p>
              {t('Enter your payment details on our secure system Payment is only taken after the lesson happens')}
            </p>
          </Col>
          <Col lg={5} xs={18} style={{ padding: '10px' }}>
            <Icon type="search" />
            <h3 style={{ color: '#877398' }}>{t('4. Learn!')}</h3>
            <p>
              {t('Enjoy your lesson with an experienced tutor and start achieving your learning goals!')}
            </p>
          </Col>
        </Row>
      </div>
    </>
  );
}
